export default "<wbm-home-header></wbm-home-header>\r\n<router-outlet></router-outlet>";